import { render, staticRenderFns } from "./NvmDashlet.vue?vue&type=template&id=63028fa0"
import script from "./NvmDashlet.vue?vue&type=script&lang=js"
export * from "./NvmDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports